import { Endpoint, FOUNDATION_ROUTES } from '@philips-emr/hpms-stipulator-commons';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import BaseController from '../BaseController';

@Controller({ fragment: 'confirmar-usuario' })
export default class ConfirmarUsuarioController extends BaseController {
  @OnMount({ target: 'panel-conf-usuario' })
  onMountConfUsuario(): void {
    const { hash } = this.historyService.getCurrentRouteParams();

    HttpService.get(Endpoint.GET.VALIDATE_HASH_CONFIRMAR_USUARIO, { hash })
      .then(() => this.historyService.push(FOUNDATION_ROUTES.CONFIRMAR_USUARIO_NOVA_SENHA, { hash }))
      .catch(() => this.historyService.push(FOUNDATION_ROUTES.CONFIRMAR_USUARIO_FALHA));
  }
}
